import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { WhatsAppConfig_delete, WhatsappTemplate_Create, WhatsappTemplate_Delete, WhatsappTemplate_ReadAllMetaTemplates } from "src/app/GlobalVariables";
import { Observable } from "rxjs";
import {  WhatsappTemplateList, WhatsappTemplateItem, WhatsappTemplateReadAllMetaTemplatesRequestDTO, WhatsappTemplateDeleteRequestDTO, WhatsappTemplateCreateRequestDTO, } from "./whatsapp-template.interface";
import { PaginatedDTO } from "src/app/Common/common.interface";

// import { WhatsappConfigDeleteRequestDTO } from "../whatsapp-config/whatsapp-config.interface";
@Injectable({
    providedIn: 'root'
})
export class WhatsappTemplateService {
    private http = inject(HttpClient);

    whatsappTemplate_Create(data: WhatsappTemplateCreateRequestDTO): Observable<WhatsappTemplateItem> {
        return this.http.post<WhatsappTemplateItem>(WhatsappTemplate_Create, data);
    }

    whatsappTemplate_Delete(data: WhatsappTemplateDeleteRequestDTO): Observable<WhatsappTemplateItem> {
        return this.http.post<WhatsappTemplateItem>(WhatsappTemplate_Delete, data);
    }

    whatsappTemplate_ReadAllMetaTemplates(data:WhatsappTemplateReadAllMetaTemplatesRequestDTO): Observable<WhatsappTemplateList> {
        return this.http.post<WhatsappTemplateList>(WhatsappTemplate_ReadAllMetaTemplates, data);
        
    }
 
    

}

